import { PaymentBanner } from "./PaymentBanner";

export default PaymentBanner;
